import {
    // acceleratedRaycast,
    // computeBoundsTree,
    // disposeBoundsTree,
    CONTAINED,
    INTERSECTED,
    NOT_INTERSECTED,
  } from 'three-mesh-bvh';
import {
    Mesh,
    BufferAttribute,
} from "three";
import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils";
import * as THREE from 'three';

export const IfcRayCastingMixin = {
    watch: {
        intersected_id(val) {
            //highlight raycasted element
            // this.removeObjectByName('highlightmesh');
            if(val !== -1) {
                // this.addHighlightMesh();
              this.setGroupIndicesByIds({name: 'highlighted', ids: [val]});
            } else {
              this.setGroupIndicesByIds({name: 'highlighted', ids: []});
            }
        }
    },
    methods: {
        raycast(event) {
            if(this.raycast_object === '') return;
            // test for better line threshold
            // let a = new THREE.Vector3(0,0,0);
            // let b = new THREE.Vector3(1,0,0);
            // console.log(a.distanceTo(b));
            // let proj_a = a.project(this.camera);
            // let proj_b = b.project(this.camera);
            // proj_a.x *= (this.size.width/2);
            // proj_a.y *= (this.size.height/2);
            // proj_b.x *= (this.size.width/2);
            // proj_b.y *= (this.size.height/2);
            // let pixel_length = proj_a.distanceTo(proj_b);
            // improve: set to raycasted location?
            // go over zoom in orthografic and 
            // var zoom = controls.target.distanceTo( controls.object.position ) in perspective

            this.mouse.x = ((event.offsetX - 1) / this.size.width) * 2 - 1; // - 1
            this.mouse.y = -((event.offsetY - 2) / this.size.height) * 2 + 1; // + 1
            
            this.raycaster.setFromCamera(this.mouse, this.camera);

            // only if clipping plane on!! -> performance
            if (this.clipping_planes.length !== 0) {
                this.raycaster.firstHitOnly = false;
            } else {
                this.raycaster.firstHitOnly = true;
            }
            
            let intersected = this.raycaster.intersectObject(this.raycast_object, true);
            for (let i = 0; i < intersected.length; i++) {
                // if (intersected.length !== 0) {
                //     let i = intersected.length-1;
                    if (!intersected[i].object.unstaged) {
                        // clipping plane
                        if (
                            (this.clipping_planes.length < 1 || this.clipping_planes[0].distanceToPoint(intersected[i].point) > 0) &&
                            (this.clipping_planes.length < 2 || this.clipping_planes[1].distanceToPoint(intersected[i].point) > 0) &&
                            (this.clipping_planes.length < 3 || this.clipping_planes[2].distanceToPoint(intersected[i].point) > 0)
                        ) {
                            let geoIndex = intersected[i].object.geometry.index.array;
                            let index;
                            if (intersected[i].faceIndex) {
                                index = 3 * intersected[i].faceIndex;
                            } else {
                                index = intersected[i].index;
                            }
                            this.intersected_id = intersected[i].object.geometry.attributes['_takting_id'].getX(geoIndex[index]);
                            this.intersected_face = intersected[i];
                            return;
                        }
                    } else if (intersected[i].object.unstaged && intersected[i].object.visible) {
                        this.intersected_id = intersected[i].object.takting_id;
                        this.intersected_name = intersected[i].object.name;
                        this.intersected_face = intersected[i];
                        return;
                    }
                // }
            }
            this.intersected_id = -1;
            this.intersected_face = {};
        },
        // click element
        selectObject(evt) {
            let takt_id = this.intersected_id;
            if (takt_id !== -1) {
                if(evt.ctrlKey) {
                    let selection_ids = this.$store.state.ProjectStructure.selected_elements.elements;
                    let set = new Set(selection_ids);
                    this.setCollectionObjects({
                        collection_name: 'selected_elements', 
                        action: set.has(`${takt_id}`) || set.has(takt_id)?'remove':'add', 
                        ids_by_target: {elements: [takt_id]}
                    });
                    set = null;
                    // if (set.has(takt_id)) {
                    //     let index = selection_ids.indexOf(takt_id);
                    //     selection_ids.splice(index, 1);
                    // } else {
                    //     selection_ids.push(takt_id);
                    // }
                } else {
                    let el  = this.$store.state.ProjectStructure.project_elements[takt_id];
                    el.type = 'elements';
                    el.id = takt_id;
                    this.active_tree_element_spatial = el;
                }
            } else {
                if(evt.ctrlKey) {
                    this.setCollectionObjects({collection_name: 'selected_elements', action: 'set', ids_by_target: {elements: []}});
                } else {
                    this.active_tree_element_spatial = false;
                }
            }
        },
        // shape selection taktarea or mouse shape selection
        getGeometrySelection(target_meshes, shape, is_taktareashape, selection_points_input) {
            // let start = new Date();
            // let intersected_ids = [];
            let intersected_ids = new Set();
            let params = {
                useBoundsTree: true,
                selectModel: false,
                selectionMode: 'intersection'
            };

            // for contains:
            let index_count_by_takting_id_temp = {};
            // let threshold = 1;

            let lower_level;
            let height;
            if (is_taktareashape && shape) {
                // lower_level = shape.lower_level;
                // height = shape.height;
                lower_level = shape.geometry.offset[1];
                height = shape.geometry.extrude_value;
            }
            
            //casting object
            let selectionPoints = [];
            // set points for the corner of the box
            // selectionPoints.length = 3 * 9;

            if (is_taktareashape && shape) {
                // shape.path.forEach(point => {
                //     selectionPoints.push(point.x, point.y, 0);
                // });
                for (let i = 0; i < shape.geometry.points_x.length; i++) {
                    selectionPoints[selectionPoints.length] = shape.geometry.points_x[i];
                    selectionPoints[selectionPoints.length] = shape.geometry.points_y[i];
                    selectionPoints[selectionPoints.length] = 0;
                }
                // shape.geometry.forEach(point => {
                //     selectionPoints.push(point.x, point.y, 0);
                // });
            } else if (selection_points_input) {
                selectionPoints = selection_points_input;
            }
            
            // //selection points for box selection
            // const ex = e.clientX;
            // const ey = e.clientY;
            //
            // const nx = ( e.clientX / this.size.width ) * 2 - 1;
            // const ny = - ( ( e.clientY / this.size.height ) * 2 - 1 );
            //
            // // set points for the corner of the box
            // selectionPoints.length = 3 * 5;
            //
            // selectionPoints[ 0 ] = startX;
            // selectionPoints[ 1 ] = startY;
            // selectionPoints[ 2 ] = 0;
            //
            // selectionPoints[ 3 ] = nx;
            // selectionPoints[ 4 ] = startY;
            // selectionPoints[ 5 ] = 0;
            //
            // selectionPoints[ 6 ] = nx;
            // selectionPoints[ 7 ] = ny;
            // selectionPoints[ 8 ] = 0;
            //
            // selectionPoints[ 9 ] = startX;
            // selectionPoints[ 10 ] = ny;
            // selectionPoints[ 11 ] = 0;
            //
            // selectionPoints[ 12 ] = startX;
            // selectionPoints[ 13 ] = startY;
            // selectionPoints[ 14 ] = 0;
            
            //create lasso segments
            let lassoSegments = [];
            
            // create scratch points and lines to use for selection
            while ( lassoSegments.length < selectionPoints.length ) {
            
                lassoSegments.push( new THREE.Line3() );
            
            }
            
            lassoSegments.length = selectionPoints.length;
            
            for ( let s = 0, l = selectionPoints.length; s < l; s += 3 ) {
            
                const line = lassoSegments[ s ];
                const sNext = ( s + 3 ) % l;
                line.start.x = selectionPoints[ s ];
                line.start.y = selectionPoints[ s + 1 ];
            
                line.end.x = selectionPoints[ sNext ];
                line.end.y = selectionPoints[ sNext + 1 ];
            
            }
            
            // let indices = [];
            
            target_meshes.forEach(target_mesh => {
                if (target_mesh.geometry.index.count !== 0) {
                let boxPoints = new Array( 8 ).fill().map( () => new THREE.Vector3() );
                let boxLines = new Array( 12 ).fill().map( () => new THREE.Line3() );
                let perBoundsSegments = [];
            
                //clone mesh
                let mesh = new Mesh(target_mesh.geometry.clone(), target_mesh.material.clone());

                //screenspace matric needed for box selection
                let toScreenSpaceMatrix;
                if (!is_taktareashape) {
                    // add center model
                    mesh.position.x = this.center_position.x;
                    mesh.position.y = this.center_position.y;
                    mesh.position.z = this.center_position.z;
                    toScreenSpaceMatrix = new THREE.Matrix4();
                    toScreenSpaceMatrix.copy( mesh.matrixWorld ).premultiply( this.camera.matrixWorldInverse ).premultiply( this.camera.projectionMatrix );
                }
            

                //rotate mesh and vertices to cast !!!
                mesh.rotation.x = Math.PI / 2;
                mesh.updateMatrix();
                mesh.geometry.applyMatrix4( mesh.matrix );
                mesh.matrix.identity();
            
                mesh.position.set( 0, 0, 0 );
                mesh.rotation.set( 0, 0, 0 );
                mesh.scale.set( 1, 1, 1 );
            
                mesh.geometry.computeBoundsTree();

                mesh.geometry.boundsTree.shapecast( {
                    intersectsBounds: ( box, isLeaf, score, depth ) => {
                    // Get the bounding box points
                    const { min, max } = box;

                    // detect if in z range only if taktarea shape
                    if (is_taktareashape) {
                        if (min.z > lower_level + height) {
                            return NOT_INTERSECTED;
                        } else if (max.z < lower_level) {
                            return NOT_INTERSECTED;
                        }
                    }
                
                    // check if bounds intersect or contain the lasso region
                    if ( ! params.useBoundsTree ) {
                
                        return INTERSECTED;
                
                    }
                
                    let index = 0;
                
                    // let minY = 20;
                    // let maxY = 0;
                    // let minX = Infinity;
                
                    let minY = Infinity;
                    let maxY = - Infinity;
                    let minX = Infinity;
                    for ( let x = 0; x <= 1; x ++ ) {
                
                        for ( let y = 0; y <= 1; y ++ ) {
                
                        for ( let z = 0; z <= 1; z ++ ) {
                
                            const v = boxPoints[ index ];
                            v.x = x === 0 ? min.x : max.x;
                            v.y = y === 0 ? min.y : max.y;
                            v.z = z === 0 ? min.z : max.z;
                            v.w = 1;

                            if (!is_taktareashape) {
                                v.applyMatrix4( toScreenSpaceMatrix ); //needed for box selection
                            }

                            index ++;
                
                            if ( v.y < minY ) minY = v.y;
                            if ( v.y > maxY ) maxY = v.y;
                            if ( v.x < minX ) minX = v.x;
                
                            // if ( v.y < minY ) v.y = minY;
                            // if ( v.y > maxY ) v.y = maxY;
                            // if ( v.x < minX ) minX = v.x;
                
                        }
                
                        }
                
                    }
                
                    // Find all the relevant segments here and cache them in the above array for
                    // subsequent child checks to use.
                    const parentSegments = perBoundsSegments[ depth - 1 ] || lassoSegments;
                    const segmentsToCheck = perBoundsSegments[ depth ] || [];
                    segmentsToCheck.length = 0;
                    perBoundsSegments[ depth ] = segmentsToCheck;
                    for ( let i = 0, l = parentSegments.length; i < l; i ++ ) {
                
                        const line = parentSegments[ i ];
                        const sx = line.start.x;
                        const sy = line.start.y;
                        const ex = line.end.x;
                        const ey = line.end.y;
                        if ( sx < minX && ex < minX ) continue;
                
                        const startAbove = sy > maxY;
                        const endAbove = ey > maxY;
                        if ( startAbove && endAbove ) continue;
                
                        const startBelow = sy < minY;
                        const endBelow = ey < minY;
                        if ( startBelow && endBelow ) continue;
                        segmentsToCheck.push( line );
                    }
                    if ( segmentsToCheck.length === 0 ) {
                        return NOT_INTERSECTED;
                    }
                    // Get the screen space hull lines
                    // const hull = this.getConvexHull( boxPoints, true );
                    // const hull = this.getConvexHull( boxPoints, !is_taktareashape ); // bugfix: early out if not taktareashape 
                    const hull = this.getConvexHull( boxPoints, false ); //early out false -> bugfix?
                    const lines = hull.map( ( p, i ) => {
                        const nextP = hull[ ( i + 1 ) % hull.length ];
                        const line = boxLines[ i ];
                        line.start.copy( p );
                        line.end.copy( nextP );
                        return line;
                    } );
                    // If a lasso point is inside the hull then it's intersected and cannot be contained
                    if ( this.pointRayCrossesSegments( segmentsToCheck[ 0 ].start, lines ) % 2 === 1 ) {
                        return INTERSECTED;
                    }
                    // check if the screen space hull is in the lasso
                    let crossings = 0;
                    for ( let i = 0, l = hull.length; i < l; i ++ ) {
                        const v = hull[ i ];
                        const pCrossings = this.pointRayCrossesSegments( v, segmentsToCheck );
                        if ( i === 0 ) {
                        crossings = pCrossings;
                        }
                        // if two points on the hull have different amounts of crossings then
                        // it can only be intersected
                        if ( crossings !== pCrossings ) {
                        return INTERSECTED;
                        }
                    }
                    // check if there are any intersections
                    for ( let i = 0, l = lines.length; i < l; i ++ ) {
                        const boxLine = lines[ i ];
                        for ( let s = 0, ls = segmentsToCheck.length; s < ls; s ++ ) {
                        if ( this.lineCrossesLine( boxLine, segmentsToCheck[ s ] ) ) {
                            return INTERSECTED;
                        }
                        }
                    }
                    return crossings % 2 === 0 ? NOT_INTERSECTED : CONTAINED;
                    },
                    intersectsTriangle: ( tri, index, contained, depth ) => {
                    let i3 = index * 3;
                    // let a = i3 + 0;
                    // let b = i3 + 1;
                    // let c = i3 + 2;
                
                    // if the parent bounds were marked as contained
                    if ( contained ) {
                
                        let geoIndex = mesh.geometry.index.array;
                        let id = mesh.geometry.attributes['_takting_id'].array[geoIndex[i3]];
                        // if (!intersected_ids.includes(id)) {
                        // // intersected_ids.push(id);
                        // intersected_ids[intersected_ids.length] = id;

                        // intersects
                        if (this.selection_mode === 'intersects') {
                            intersected_ids.add(id);
                        } 
                        // contains
                        else {
                            if (!index_count_by_takting_id_temp[id]) {
                                index_count_by_takting_id_temp[id] = 0;
                            }
                            index_count_by_takting_id_temp[id] += 3;
                            if (index_count_by_takting_id_temp[id] / this.index_count_by_takting_id[id] >= this.contains_threshold) {
                                intersected_ids.add(id);
                            }
                        }
                        // }
                        // indices.push( a, b, c );
                        return params.selectModel;
                    }
                    // check all the segments if using no bounds tree
                    const segmentsToCheck = params.useBoundsTree ? perBoundsSegments[ depth ] : lassoSegments;
                    if ( params.selectionMode === 'centroid' ) {
                
                        // get the center of the triangle
                        const centroid = tri.a.add( tri.b ).add( tri.c ).multiplyScalar( 1 / 3 );
                        if (!is_taktareashape) {
                            centroid.applyMatrix4( toScreenSpaceMatrix ); //needed for box selection
                        }
                
                        // counting the crossings
                        const crossings = this.pointRayCrossesSegments( centroid, segmentsToCheck );
                        if ( crossings % 2 === 1 ) {
                
                        let geoIndex = mesh.geometry.index.array;
                        let id = mesh.geometry.attributes['_takting_id'].array[geoIndex[i3]];
                        // if (!intersected_ids.includes(id)) {
                        //     // intersected_ids.push(id);
                        //     intersected_ids[intersected_ids.length] = id;
                        if (!index_count_by_takting_id_temp[id]) {
                            index_count_by_takting_id_temp[id] = 0;
                        }
                        index_count_by_takting_id_temp[id] += 3;
                        if (index_count_by_takting_id_temp[id] / this.index_count_by_takting_id[id] >= this.contains_threshold) {
                            intersected_ids.add(id);
                        }
                        // }
                        // indices.push( a, b, c );
                        return params.selectModel;
                        }
                    } else if ( params.selectionMode === 'intersection' ) {
                        // get the projected vertices
                        const vertices = [
                        tri.a,
                        tri.b,
                        tri.c,
                        ];
                        for ( let j = 0; j < 3; j ++ ) {
                        const v = vertices[ j ];

                        if (!is_taktareashape) {
                            v.applyMatrix4( toScreenSpaceMatrix ); //needed for box selection
                        }
                        
                        const crossings = this.pointRayCrossesSegments( v, segmentsToCheck );
                        if ( crossings % 2 === 1 ) {
                
                            let geoIndex = mesh.geometry.index.array;
                            let id = mesh.geometry.attributes['_takting_id'].array[geoIndex[i3]];
                            // if (!intersected_ids.includes(id)) {
                            // // intersected_ids.push(id);
                            // intersected_ids[intersected_ids.length] = id;
                            if (!index_count_by_takting_id_temp[id]) {
                                index_count_by_takting_id_temp[id] = 0;
                            }
                            index_count_by_takting_id_temp[id] += 3;
                            if (index_count_by_takting_id_temp[id] / this.index_count_by_takting_id[id] >= this.contains_threshold) {
                                intersected_ids.add(id);
                            }
                            // }
                            // indices.push( a, b, c );
                            return params.selectModel;
                        }
                        }
                        // get the lines for the triangle
                        const lines = [
                        boxLines[ 0 ],
                        boxLines[ 1 ],
                        boxLines[ 2 ],
                        ];
                        lines[ 0 ].start.copy( tri.a );
                        lines[ 0 ].end.copy( tri.b );
                
                        lines[ 1 ].start.copy( tri.b );
                        lines[ 1 ].end.copy( tri.c );
                
                        lines[ 2 ].start.copy( tri.c );
                        lines[ 2 ].end.copy( tri.a );
                
                        for ( let i = 0; i < 3; i ++ ) {
                        const l = lines[ i ];
                        for ( let s = 0, sl = segmentsToCheck.length; s < sl; s ++ ) {
                            if ( this.lineCrossesLine( l, segmentsToCheck[ s ] ) ) {
                
                            let geoIndex = mesh.geometry.index.array;
                            let id = mesh.geometry.attributes['_takting_id'].array[geoIndex[i3]];
                            // if (!intersected_ids.includes(id)) {
                            //     // intersected_ids.push(id);
                            //     intersected_ids[intersected_ids.length] = id;
                            if (!index_count_by_takting_id_temp[id]) {
                                index_count_by_takting_id_temp[id] = 0;
                            }
                            index_count_by_takting_id_temp[id] += 3;
                            if (index_count_by_takting_id_temp[id] / this.index_count_by_takting_id[id] >= this.contains_threshold) {
                                intersected_ids.add(id);
                            }
                            // }
                            // indices.push( a, b, c );
                            return params.selectModel;
                            }
                        }
                        }
                    }
                    return false;
                    }
                });
            }
            });
            let intersected_ids_arr = Array.from(intersected_ids);
            // console.log(`${index_count_by_takting_id_temp[intersected_ids_arr[0]]} / ${this.index_count_by_takting_id[intersected_ids_arr[0]]}`);
            // console.log(new Date().getTime() - start.getTime()); // 2668 - 2697 ; 2232 - 2313; 1781 - 1822; 1515 - 1538
            return intersected_ids_arr;
            },
        // Math Functions
        // https://www.geeksforgeeks.org/convex-hull-set-2-graham-scan/
        getConvexHull( points, early_out ) {

            function orientation( p, q, r ) {
                const val =
                    ( q.y - p.y ) * ( r.x - q.x ) -
                    ( q.x - p.x ) * ( r.y - q.y );

                if ( val == 0 ) {
                    return 0; // colinear

                }

                // clock or counterclock wise
                return ( val > 0 ) ? 1 : 2;

            }

            function distSq( p1, p2 ) {

                return ( p1.x - p2.x ) * ( p1.x - p2.x ) +
                    ( p1.y - p2.y ) * ( p1.y - p2.y );

            }

            function compare( p1, p2 ) {

            // Find orientation
            const o = orientation( p0, p1, p2 );
            if ( o == 0 )
            return ( distSq( p0, p2 ) >= distSq( p0, p1 ) ) ? - 1 : 1;

            return ( o == 2 ) ? - 1 : 1;

            }
            // find the lowest point in 2d
            let lowestY = Infinity;
            let lowestIndex = - 1;
            for ( let i = 0, l = points.length; i < l; i ++ ) {

                const p = points[ i ];
                if ( p.y < lowestY ) {

                    lowestIndex = i;
                    lowestY = p.y;

                }

            }
            // sort the points
            const p0 = points[ lowestIndex ];
            points[ lowestIndex ] = points[ 0 ];
            points[ 0 ] = p0;

            points = points.sort( compare );

            // filter the points
            let m = 1;
            const n = points.length;
            for ( let i = 1; i < n; i ++ ) {

                while ( i < n - 1 && orientation( p0, points[ i ], points[ i + 1 ] ) == 0 ) {

                    i ++;

                }

                points[ m ] = points[ i ];
                m ++;

            }
            // early out if we don't have enough points for a hull -> removed fix problem?
            // fix: early out = false if is_taktareashape
            if ( early_out && m < 3 ) return null;
            // if ( early_out && m < 3 ) console.log('early out');
            // end fix of problem

            // generate the hull
            const hull = [ points[ 0 ], points[ 1 ], points[ 2 ] ];
            for ( let i = 3; i < m; i ++ ) {

                while ( orientation( hull[ hull.length - 2 ], hull[ hull.length - 1 ], points[ i ] ) !== 2 ) {

                    hull.pop();

                }

                hull.push( points[ i ] );

            }
            // if ( early_out && m < 3 ) console.log(hull);
            return hull;

        },

        pointRayCrossesLine( point, line, prevDirection, thisDirection ) {

            const { start, end } = line;
            const px = point.x;
            const py = point.y;

            const sy = start.y;
            const ey = end.y;

            if ( sy === ey ) return false;

            if ( py > sy && py > ey ) return false; // above
            if ( py < sy && py < ey ) return false; // below

            const sx = start.x;
            const ex = end.x;
            if ( px > sx && px > ex ) return false; // right
            if ( px < sx && px < ex ) { // left

                if ( py === sy && prevDirection !== thisDirection ) {

                    return false;

                }

                return true;

            }

            // check the side
            const dx = ex - sx;
            const dy = ey - sy;
            const perpx = dy;
            const perpy = - dx;

            const pdx = px - sx;
            const pdy = py - sy;

            const dot = perpx * pdx + perpy * pdy;

            if ( Math.sign( dot ) !== Math.sign( perpx ) ) {

                return true;

            }

            return false;

        },

        pointRayCrossesSegments( point, segments ) {

            let crossings = 0;
            const firstSeg = segments[ segments.length - 1 ];
            let prevDirection = firstSeg.start.y > firstSeg.end.y;
            for ( let s = 0, l = segments.length; s < l; s ++ ) {

                const line = segments[ s ];
                const thisDirection = line.start.y > line.end.y;
                if ( this.pointRayCrossesLine( point, line, prevDirection, thisDirection ) ) {

                    crossings ++;

                }

                prevDirection = thisDirection;

            }

            return crossings;

        },

        // https://stackoverflow.com/questions/3838329/how-can-i-check-if-two-segments-intersect
        lineCrossesLine( l1, l2 ) {

            function ccw( A, B, C ) {

                return ( C.y - A.y ) * ( B.x - A.x ) > ( B.y - A.y ) * ( C.x - A.x );

            }

            const A = l1.start;
            const B = l1.end;

            const C = l2.start;
            const D = l2.end;

            return ccw( A, C, D ) !== ccw( B, C, D ) && ccw( A, B, C ) !== ccw( A, B, D );

        },

        // handle mouse shape selection
        shapeSelectionMouseDown(e) {

            this.prevX = e.clientX;
            this.prevY = e.clientY;

            // this.startX = ( e.clientX / this.size.width ) * 2 - 1;
            // this.startY = - ( ( e.clientY / this.size.height ) * 2 - 1 );
            this.startX = ( (e.offsetX - 1) / this.size.width ) * 2 - 1;
            this.startY = - ( ( (e.offsetY - 1) / this.size.height ) * 2 - 1 );
            this.selectionPoints.length = 0;
            this.shape_selection_dragging = true;
        },
        shapeSelectionMouseUp() {


            this.selectionShape.visible = false;
            this.shape_selection_dragging = false;
            if ( this.selectionPoints.length ) {
    
                this.selectionNeedsUpdate = true;
    
            }
        },
        shapeSelectionMouseMove(e) {


            let ex = e.clientX;
            let ey = e.clientY;
    
            // let nx = ( e.clientX / this.size.width ) * 2 - 1;
            // let ny = - ( ( e.clientY / this.size.height ) * 2 - 1 );

            let nx = ( (e.offsetX - 1) / this.size.width ) * 2 - 1;
            let ny = - ( ( (e.offsetY - 1) / this.size.height ) * 2 - 1 );
    
            // console.log(this.startX);
            // console.log(this.startY);
            // console.log(nx);
            // console.log(ny);

            if ( this.shape_selection_mode === 'box' ) {

                // set points for the corner of the box
                this.selectionPoints.length = 3 * 5;
    
                this.selectionPoints[ 0 ] = this.startX;
                this.selectionPoints[ 1 ] = this.startY;
                this.selectionPoints[ 2 ] = 0;
    
                this.selectionPoints[ 3 ] = nx;
                this.selectionPoints[ 4 ] = this.startY;
                this.selectionPoints[ 5 ] = 0;
    
                this.selectionPoints[ 6 ] = nx;
                this.selectionPoints[ 7 ] = ny;
                this.selectionPoints[ 8 ] = 0;
    
                this.selectionPoints[ 9 ] = this.startX;
                this.selectionPoints[ 10 ] = ny;
                this.selectionPoints[ 11 ] = 0;
    
                this.selectionPoints[ 12 ] = this.startX;
                this.selectionPoints[ 13 ] = this.startY;
                this.selectionPoints[ 14 ] = 0;
    
                if ( ex !== this.prevX || ey !== this.prevY ) {
    
                    this.selectionShapeNeedsUpdate = true;
    
                }
    
                this.prevX = ex;
                this.prevY = ey;
                this.selectionShape.visible = true;
                if ( this.shape_selection_live_update ) {
    
                    this.selectionNeedsUpdate = true;
    
                }
    
            } else {
    
                // If the mouse hasn't moved a lot since the last point
                if (
                    Math.abs( ex - this.prevX ) >= 3 ||
                    Math.abs( ey - this.prevY ) >= 3
                ) {
    
                    // Check if the mouse moved in roughly the same direction as the previous point
                    // and replace it if so.
                    const i = ( this.selectionPoints.length / 3 ) - 1;
                    const i3 = i * 3;
                    let doReplace = false;
                    if ( this.selectionPoints.length > 3 ) {
    
                        // prev segment direction
                        this.tempVec0.set( this.selectionPoints[ i3 - 3 ], this.selectionPoints[ i3 - 3 + 1 ] );
                        this.tempVec1.set( this.selectionPoints[ i3 ], this.selectionPoints[ i3 + 1 ] );
                        this.tempVec1.sub( this.tempVec0 ).normalize();
    
                        // this segment direction
                        this.tempVec0.set( this.selectionPoints[ i3 ], this.selectionPoints[ i3 + 1 ] );
                        this.tempVec2.set( nx, ny );
                        this.tempVec2.sub( this.tempVec0 ).normalize();
    
                        const dot = this.tempVec1.dot( this.tempVec2 );
                        doReplace = dot > 0.99;
    
                    }
    
                    if ( doReplace ) {
    
                        this.selectionPoints[ i3 ] = nx;
                        this.selectionPoints[ i3 + 1 ] = ny;
    
                    } else {
    
                        this.selectionPoints.push( nx, ny, 0 );
    
                    }
    
                    this.selectionShapeNeedsUpdate = true;
                    this.selectionShape.visible = true;
    
                    this.prevX = ex;
                    this.prevY = ey;
    
                    if ( this.shape_selection_live_update ) {
    
                        this.selectionNeedsUpdate = true;
    
                    }
    
                }
    
            }
        },
        checkSelectionUpdates() {
            // Update the selection lasso lines
            if ( this.selectionShapeNeedsUpdate ) {
                
                if ( this.shape_selection_mode === 'lasso' ) {

                    let ogLength = this.selectionPoints.length;
                    this.selectionPoints.push(
                        this.selectionPoints[ 0 ],
                        this.selectionPoints[ 1 ],
                        this.selectionPoints[ 2 ]
                    );

                    this.selectionShape.geometry.setAttribute(
                        'position',
                        new THREE.Float32BufferAttribute( this.selectionPoints, 3, false )
                    );

                    this.selectionPoints.length = ogLength;

                } else {

                    this.selectionShape.geometry.setAttribute(
                        'position',
                        new THREE.Float32BufferAttribute( this.selectionPoints, 3, false )
                    );

                }

                this.selectionShape.frustumCulled = false;
                this.selectionShapeNeedsUpdate = false;

            }

            if ( this.selectionNeedsUpdate ) {

                this.selectionNeedsUpdate = false;

                if ( this.selectionPoints.length > 0 ) {

                    this.updateSelection();

                }

            }
            // console.log(this.camera.fov);
            // console.log(this.camera.aspect);
            // if (!this.camera.isOrthographicCamera) {
                let yScale = Math.tan( THREE.MathUtils.DEG2RAD * this.camera.fov / 2 ) * this.selectionShape.position.z;
                this.selectionShape.scale.set( - yScale * this.camera.aspect, - yScale, 1 );
            // }
        },
        updateSelection() {
            let ids = this.getGeometrySelection(this.visible_normal_group.children, false, false, this.selectionPoints);
            this.setCollectionObjects({collection_name: 'selected_elements', action: 'set', ids_by_target: {elements: ids}});
        },

        // old....
        addHighlightMesh() {
            let test_geo;
            if (this.intersected_face.object.unstaged) {
                test_geo = this.intersected_face.object.geometry.clone();
            } else {
                if (this.elements_by_takting_id[this.intersected_id].length === 1) {
                test_geo = this.intersected_face.object.geometry.clone();
                test_geo.setIndex(new BufferAttribute(Uint32Array.from(this.elements_by_takting_id[this.intersected_id][0].array), 1));
                } else {
                let geometries = [];
                this.elements_by_takting_id[this.intersected_id].forEach(subelement => {
                    let mesh = this.scene.getObjectByName(subelement.mesh);
                    let mesh_geometry = mesh.geometry.clone();
                    mesh_geometry.setIndex(new BufferAttribute(Uint32Array.from(subelement.array), 1));
                    geometries.push(mesh_geometry);
                });
                test_geo = BufferGeometryUtils.mergeBufferGeometries(geometries);
                test_geo.computeBoundsTree();
                }
            }
            let test_mesh = new Mesh(test_geo, this.highlight_material);
            test_mesh.name = 'highlightmesh';
            test_mesh.renderOrder = 20;
            test_mesh.rotateX( Math.PI / 2);
            //center model
            test_mesh.position.set(this.center_position.x, this.center_position.y, this.center_position.z);
            this.scene.add(test_mesh);
        },
    }
}